import isEqual from 'lodash-es/isEqual'

import { updateStateValue } from '../../../../utils/react'
import { getListingDraftFormValues } from '../../RentalPortalListing.utils'

export function getListingDraftSaveAction(nextDraftAction) {
  return currentDraft => {
    const currentValues = getListingDraftFormValues(currentDraft)
    const nextValues = updateStateValue(nextDraftAction, currentValues)

    if (!nextValues) {
      return nextValues
    }

    return isEqual(nextValues, currentValues)
      ? currentDraft
      : { savedAt: new Date().toISOString(), values: nextValues }
  }
}
